import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router';
import { UtilsHelper } from '@commons/utils';
import { Store } from '@ngxs/store';
import { AddUrlVisited } from '@stores/visited-url/visited-url.action';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisitedUrlGuard implements CanActivate {
  constructor(private readonly store: Store) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> {
    const url = UtilsHelper.getResolvedUrl(route);
    this.store.dispatch(new AddUrlVisited(url));
    return true;
  }
}
